import {getAuth, signOut} from "firebase/auth";
import axios from "axios";
import * as Sentry from "@sentry/react";

const axiosApi = axios.create();

// Request interceptor for API calls
axiosApi.interceptors.request.use(
  async config => {
    let token = window.sessionStorage.getItem('id_token');
    
    // Si no hay token en sessionStorage, intentar obtenerlo de Firebase
    if (!token) {
      try {
        const auth = getAuth();
        if (auth.currentUser) {
          token = await auth.currentUser.getIdToken(/* forceRefresh */ false);
          window.sessionStorage.setItem('id_token', token);
        }
      } catch (error) {
        console.error('Error obteniendo credencial de Firebase');
      }
    }
    
    config.headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
    return config;
  },
  error => {
    Promise.reject(error)
});

// Response interceptor for API calls
axiosApi.interceptors.response.use((response) => {
  return response
}, async function (error) {
  const originalRequest = error.config;
  
  // Verificar si hay un error de respuesta y si es 401 o 403
  if (error.response && (error.response.status === 403 || error.response.status === 401) && !originalRequest._retry) {
    originalRequest._retry = true;
    console.log("Refrescando credencial");
    try {
      const auth = getAuth();
      if (auth.currentUser) {
        const token = await auth.currentUser.getIdToken(/* forceRefresh */ true);
        window.sessionStorage.setItem('id_token', token);
        // Actualizar el header de la petición original
        originalRequest.headers['Authorization'] = 'Bearer ' + token;
        axiosApi.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        return axiosApi(originalRequest);
      }
    } catch (refreshError) {
      // Refrescar el propio token de Firebase falló: eso sí es sesión/credencial rota.
      console.error('Error refrescando credencial');
      if (window.signout) {
          window.signout();
      } else {
          signOut(getAuth()).then().catch().finally(() => {
              sessionStorage.removeItem("id_token");
              window.location.href = "/login";
          });
      }
      Sentry.captureMessage("Invalid credential when refreshing, force logout");
      return Promise.reject(refreshError);
    }
  }
  // Un 401/403 persistente TRAS refrescar el token con éxito no es sesión inválida --
  // es que ese endpoint concreto no autoriza a este usuario para ese recurso (ej. un
  // practitioner sin rol admin contra un endpoint /admin/*). Forzar logout global aquí
  // mataba la sesión entera por un permiso puntual que el caller ya sabía manejar.
  return Promise.reject(error);
});

export default axiosApi;
